/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button } from "../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CourtBookingSharePaymentLink,
  GetBookedCourtDetail,
} from "../../../utilities/api/courtBooking";
import { CheckReschedule, LableFromEnums } from "../../../utilities";
import { ConfirmCancelModal } from "./ConfirmCancelModal";
import { ToastContainer, toast } from "react-toastify";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { CourtsBookingSummary } from "./CourtsBookingSummary";

const CourtBookingDetails = () => {
  const [openModal, setOpenModal] = useState(false);
  const [printing, setPrinting] = useState(false);
  const [modalName, setModalName] = useState("");
  const [totalTax, setTotalTax] = useState(0);
  const EnumsObj = { ...useAppSelector((state) => state.enumsArray.Enums) };
  const { name } = useAppSelector((state) => state.verifiedUser.UserRole?.role);
  const id = useLocation().state;
  const navigate = useNavigate();
  const [bookingDetails, setBookingDetails] = useState<any>({});
  const componentRef = useRef<HTMLDivElement>(null);

  const GetData = async () => {
    const result = await GetBookedCourtDetail(id);
    if (result?.statusCode === 200) {
      setBookingDetails(result.data);
      let getTotalTax = 0;
      result.data.bookingTaxes.forEach((_tax: any) => {
        getTotalTax += _tax?.percentage;
      });

      setTotalTax(getTotalTax);
    } else {
      toast.error(result.response.data.message);
    }
  };

  useEffect(() => {
    GetData();
  }, []);

  const getFormatedDate = (_date: string) => {
    const [_dd, _mm, _yy] = _date?.split?.("/") || [];
    return `${_mm}/${_dd}/${_yy}`;
  };

  const IsReschedule =
    ["confirmed", "pending", "ongoing"].includes(bookingDetails.status) &&
    !CheckReschedule(
      `${bookingDetails.bookingSlots?.length > 0 &&
      getFormatedDate(
        bookingDetails.bookingSlots[bookingDetails.bookingSlots?.length - 1]
          .bookingDate
      ) +
      " " +
      bookingDetails.bookingSlots[bookingDetails.bookingSlots?.length - 1]
        .fromTime
      }`
    );
  const IsCancel =
    bookingDetails.paymentStatus === "pending" &&
    ["confirmed", "completed", "pending"].includes(bookingDetails.status);
  const IsRefund =
    ["paid", "partially_paid"].includes(bookingDetails.paymentStatus) &&
    ["confirmed", "completed", "pending", "cancelled"].includes(
      bookingDetails.status
    );
  const IsCollectCash =
    ["pending", "partially_paid"].includes(bookingDetails.paymentStatus) &&
    bookingDetails.status !== "cancelled";

  const handleClose = () => {
    setOpenModal(false);
  };
  const handleShowCollectcash = () => {
    setModalName("Collect Cash");
    setOpenModal(true);
  };
  const handleShowCancel = () => {
    setModalName("Cancel Booking");
    setOpenModal(true);
  };

  const handleReschedule = () => {
    navigate("/reschedule-court-booking", { state: bookingDetails });
  };

  const handleRefund = () => {
    setModalName("Refund Court Booking");
    setOpenModal(true);
  };
  const handlePrint = () => {
    setPrinting(true);
    window.open(
      "/printing/?type=summary&prefix=CB&id=" + bookingDetails.id + "&hash=" + bookingDetails.hash,
      "_blank"
    );
    setTimeout(() => {
      setPrinting(false);
    }, 2000);


  };

  const handleInvoice = async (e: any) => {
    e.preventDefault();

    window.open(
      "/printing/?type=invoice&prefix=CB&id=" + bookingDetails.id + "&hash=" + bookingDetails.hash,
      "_blank"
    );
  };

  const handleSharePaymentLink = async () => {
    let _result = await CourtBookingSharePaymentLink(id);
    if (_result.status === 200) {
      toast.success(_result.data.message);
    } else {
      toast.error(_result.response.data.message);
    }
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <div className="page-title align-items-center d-flex justify-content-between">
              <Card.Title className="mb-0">Booking Details</Card.Title>
            </div>
            <hr />
            <Col lg={12}>
              <div className="reschedule-details">
                <Row className="text-start row-mb">
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Customer Name
                    </span>
                    <span className="user-info">
                      {bookingDetails?.user?.firstName}{" "}
                      {bookingDetails?.user?.lastName}
                    </span>
                  </Col>
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Booking Status
                    </span>
                    <span className="user-info">
                      {LableFromEnums(bookingDetails.status, EnumsObj)}
                    </span>
                  </Col>
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Court Name
                    </span>
                    <span className="user-info">
                      {bookingDetails.courtName}
                    </span>
                  </Col>
                </Row>
                <Row className="text-start row-mb">
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Contact Number
                    </span>
                    <span className="user-info">
                      {bookingDetails.user?.countryCode}{" "}
                      {bookingDetails.user?.phone}
                    </span>
                  </Col>
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Payment Status
                    </span>
                    <span className="user-info">
                      {LableFromEnums(bookingDetails.paymentStatus, EnumsObj)}
                    </span>
                  </Col>
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Sports Name
                    </span>
                    <span className="user-info">
                      {bookingDetails.sportName}
                    </span>
                  </Col>
                </Row>
                <Row className="text-start row-mb">
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Booking Type
                    </span>
                    <span className="user-info">
                      {LableFromEnums(bookingDetails.bookingType, EnumsObj)}{" "}
                      Booking
                    </span>
                  </Col>
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Payment Mode
                    </span>
                    <span className="user-info">
                      {bookingDetails?.bookingPayments?.length > 0 &&
                        LableFromEnums(
                          bookingDetails?.bookingPayments[
                            bookingDetails?.bookingPayments?.length - 1
                          ]?.payment?.mode,
                          EnumsObj
                        )}
                    </span>
                  </Col>
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Booked by
                    </span>
                    <span className="user-info">
                      {bookingDetails.createdByUser?.firstName}{" "}
                      {bookingDetails.createdByUser?.lastName}
                    </span>
                  </Col>
                </Row>
                <Row className="text-start">
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Payment Method
                    </span>
                    <span className="user-info">
                      {bookingDetails?.bookingPayments?.length > 0
                        ? LableFromEnums(
                          bookingDetails.bookingPayments[
                            bookingDetails.bookingPayments.length - 1
                          ].payment.method || "-",
                          EnumsObj
                        )
                        : "-"}
                    </span>
                  </Col>
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Company Name
                    </span>
                    <span className="user-info">
                      {bookingDetails?.companyName || "-"}
                    </span>
                  </Col>
                  <Col lg={4}>
                    <span className="user-info-title text-info text-uppercase d-block mb-2">
                      Amount{" "}
                    </span>
                    <span className="user-info">
                      <span className="rupees-symbol">&#8377;</span>{" "}
                      {bookingDetails.totalAmount?.toFixed(2)}
                    </span>
                  </Col>
                </Row>
              </div>
            </Col>
            <hr />
            <Row className="text-start row-mb">
              <Col lg={12}>
                <div className="fw-semibold">Summary: </div>
              </Col>
            </Row>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Slot</th>
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {bookingDetails.bookingSlots?.map((item: any) => {
                  return (
                    <tr key={item.id}>
                      <td>{item.bookingDate}</td>
                      <td>
                        {item.fromTime} to {item.toTime}
                      </td>
                      <td>
                        <span className="rupees-symbol">&#8377;</span>{" "}
                        {item.ratePerSlot}
                      </td>
                      <td
                        className={
                          item.status === "cancelled" ? "text-danger" : ""
                        }
                      >
                        {LableFromEnums(item.status, EnumsObj)}
                      </td>
                    </tr>
                  );
                })}

                <tr className="table-group-divider">
                  <td></td>
                  <td></td>
                  <th>Sub Amount</th>
                  <td>
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {bookingDetails.subTotal?.toFixed(2)}
                  </td>
                </tr>
                {bookingDetails?.discount > 0 && (
                  <tr>
                    <td></td>
                    <td></td>
                    <th>Discount</th>
                    <td>
                      -<span className="rupees-symbol">&#8377;</span>{" "}
                      {bookingDetails?.discount?.toFixed(2)}
                    </td>
                  </tr>
                )}
                <tr>
                  <td></td>
                  <td></td>
                  <th>Total Tax ({totalTax}%)</th>
                  <td>
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {bookingDetails.totalTax?.toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <th>Payable Amount</th>
                  <td>
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {Math.floor(bookingDetails.totalAmount)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <th>Paid Amount</th>
                  <td>
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {Math.round(bookingDetails.totalPaidAmount)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <th>Balance Amount</th>
                  <td>
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {Math.round(
                      bookingDetails.totalAmount -
                      bookingDetails.totalPaidAmount
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
            <Row className="text-start row-mb">
              <Col lg={6}>
                <div className="fw-semibold">
                  <span className="d-block">Payment Details :</span>
                  {bookingDetails.bookingPayments?.map((item: any) => {
                    return (
                      <span
                        key={item.paymentId}
                        className="badge bg-primary me-3 mb-1"
                      >
                        Amount - <span className="rupees-symbol">&#8377;</span>{" "}
                        {item.payment.payableAmount?.toFixed(2)}, Mode -{" "}
                        {LableFromEnums(item.payment.mode, EnumsObj)}, Method -{" "}
                        {LableFromEnums(item.payment.method, EnumsObj)}, Status
                        - {LableFromEnums(item.payment.status, EnumsObj)}
                      </span>
                    );
                  })}
                </div>
              </Col>
              {bookingDetails.bookingRewards?.length !== 0 && (
                <Col lg={6}>
                  <div className="fw-semibold">
                    <span className="d-block">Rewards Details : </span>
                    {bookingDetails.bookingRewards?.map((item: any) => {
                      return (
                        <span
                          key={item.id}
                          className={
                            item.userReward.rewardPoints < 0
                              ? "badge bg-primary me-3 mb-1"
                              : "badge bg-success me-3 mb-1"
                          }
                        >
                          Reward Point : {item.userReward.rewardPoints}, Action
                          : {LableFromEnums(item.userReward.action, EnumsObj)}
                        </span>
                      );
                    })}
                  </div>
                </Col>
              )}
              {bookingDetails.bookingRemarks?.length !== 0 && (
                <Col lg={6}>
                  <div className="fw-semibold">
                    <span className="d-block">Remarks : </span>
                    {bookingDetails.bookingRemarks?.map((item: any) => {
                      return (
                        <span
                          key={item.id}
                          className="badge bg-success me-3 mb-1"
                        >
                          Date : {item.createdAt}, Remark For :{" "}
                          {LableFromEnums(item.remarkFor, EnumsObj)}, Remark :{" "}
                          {item.remarkText}
                        </span>
                      );
                    })}
                  </div>
                </Col>
              )}
            </Row>
            <hr />
            <Row>
              <Col lg={8} className="text-start">
                <Button
                  onClick={handleSharePaymentLink}
                  type="button"
                  bname="Share Payment Link"
                  name="sharepaymentlink"
                  id="sharepaymentlink"
                  className={
                    IsCollectCash
                      ? "btn btn-primary rounded-1 me-3"
                      : "btn btn-primary rounded-1 me-3 d-none"
                  }
                ></Button>
                <Button
                  onClick={handleShowCollectcash}
                  type="button"
                  bname="Collect Cash"
                  name="collectcash"
                  id="collectcash"
                  className={
                    IsCollectCash
                      ? "btn btn-primary rounded-1 me-3"
                      : "btn btn-primary rounded-1 me-3 d-none"
                  }
                ></Button>

                <Button
                  onClick={handleReschedule}
                  type="button"
                  bname="Reschedule"
                  name="reschedule"
                  id="reschedule"
                  className={
                    IsReschedule
                      ? "btn btn-light rounded-1 me-3"
                      : "btn btn-light rounded-1 me-3 d-none"
                  }
                ></Button>
                {name === "SUPER_ADMIN" && (
                  <>
                    <Button
                      onClick={handleShowCancel}
                      type="button"
                      bname="Cancel Booking"
                      name="cancelbooking"
                      id="cancelbooking"
                      className={
                        IsCancel
                          ? "btn btn-light rounded-1 me-3"
                          : "btn btn-light rounded-1 me-3 d-none"
                      }
                    ></Button>
                    <Button
                      onClick={handleRefund}
                      type="button"
                      bname="Refund"
                      name="refund"
                      id="refund"
                      className={
                        IsRefund
                          ? "btn btn-light rounded-1 me-3"
                          : "btn btn-light rounded-1 me-3 d-none"
                      }
                    ></Button>
                  </>
                )}
              </Col>
              <Col lg={4} className="text-end">
                {bookingDetails.status === "completed" &&
                  bookingDetails.paymentStatus === "paid" ? (
                  <Button
                    onClick={handleInvoice}
                    type="button"
                    bname="Print Invoice"
                    name="print-invoice"
                    id="print-invoice"
                    className="btn btn-primary rounded-1"
                  ></Button>
                ) : (
                  <Button
                    onClick={handlePrint}
                    type="button"
                    name="printsummary"
                    id="printsummary"
                    className="btn btn-primary rounded-1 "
                    bname={printing ? "Printing Summary" : "Print Summary"}
                    disabled={printing}
                  ></Button>
                )}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
      <div style={{ display: "none" }}>
        <CourtsBookingSummary newRef={componentRef} />
      </div>
      <ConfirmCancelModal
        show={openModal}
        handleClose={handleClose}
        name={modalName}
        id={bookingDetails.id}
        GetData={GetData}
      />
      <ToastContainer />
    </>
  );
};
export { CourtBookingDetails };
